const COLOR_NAME = Object.freeze({
  grayLight: '#BEBEBE',
  grayDark: '#535353',
  black: '#252629',
  purpleLight: '#EDD9FF',
  purple: '#AF6DD1',
  purpleDark: '#5F1C81',
  greenLight: '#B8E986',
  green: '#4E9201',
  blueLight: '#74A6FA',
  blue: '#3C78FD',
  blueMatte: '#3B5998',
  blueNavy: '#002474',
  yellow: '#FFF362',
  orange: '#FA9F1D',
  pinkLight: '#CB91FF',
  red: '#E32E45',
  redDeep: '#9E034C',
  redDark: '#7F033E',
  // NOTE: there are two default categories whose colors DO NOT come from the picker
  defaultGreen: '#3A8463', // Holiday
  defaultPurple: '#821BB8', // Meeting with Slick
});

export default COLOR_NAME;
